import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { performRentalPortalApplicantTransition } from '../../../../../../api'
import { useNotification } from '../../../../../../hooks'
import { isApiConflictStatus } from '../../../../../../utils/api'
import { ConfirmationModal } from '../../../../../Confirmation'
import { getRentalPortalApplicantIdentityLabel } from '../../../../../RentalPortalApplicant'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import { QA_NAME_APPLICANT_TRANSITION_CONFIRMATION } from '../../RentalPortalApplicantProfileHeaderStageSelect.constants'
import { getApplicantTransitionNotifications } from '../../RentalPortalApplicantProfileHeaderStageSelect.utils'

export function useApplicantConfirmedTransition() {
  const { t } = useTranslation()

  const { handleAddSuccessNotification } = useNotification()

  const {
    applicantData,
    applicantId,
    handleCloseModal,
    handleEntityReload,
    setModal,
  } = useApplicantProfileContext()

  const [isTransitionSaving, setTransitionSaving] = useState(false)

  function handleOpenTransitionConfirmation({ error, transition }) {
    const notifications = error
      ? getApplicantTransitionNotifications({ error, t })
      : null

    function handleSubmitTransition() {
      setTransitionSaving(true)

      return performRentalPortalApplicantTransition({
        action: transition.action,
        id: applicantId,
      })
        .then(() => {
          handleCloseModal()

          handleAddSuccessNotification(transition.notificationKey)

          return handleEntityReload()
        })
        .catch(nextError => {
          handleOpenTransitionConfirmation({
            error: nextError,
            transition,
          })

          return isApiConflictStatus(nextError?.response?.status)
            ? handleEntityReload()
            : null
        })
        .finally(() => {
          setTransitionSaving(false)
        })
    }

    setModal(
      <ConfirmationModal
        actionButtonsProps={{ submitText: t(transition.submitKey) }}
        description={t(transition.textKey, {
          name: getRentalPortalApplicantIdentityLabel({
            applicant: applicantData,
            t,
          }),
        })}
        notifications={notifications}
        notificationsProps={{ notifications }}
        qaName={QA_NAME_APPLICANT_TRANSITION_CONFIRMATION}
        title={t(transition.titleKey)}
        onCancel={handleCloseModal}
        onSubmit={handleSubmitTransition}
      />
    )
  }

  function handleClickConfirmedTransition(transition) {
    handleOpenTransitionConfirmation({ error: null, transition })
  }

  return { handleClickConfirmedTransition, isTransitionSaving }
}
